import { render } from "./EditList.vue?vue&type=template&id=667bbf0e&scoped=true"
import script from "./EditList.vue?vue&type=script&lang=js"
export * from "./EditList.vue?vue&type=script&lang=js"

import "./EditList.vue?vue&type=style&index=0&id=667bbf0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667bbf0e"]])

export default __exports__